import { render, staticRenderFns } from "./datatable-sync-control.vue?vue&type=template&id=7445c6b8&"
import script from "./datatable-sync-control.vue?vue&type=script&lang=js&"
export * from "./datatable-sync-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports